export enum ProfileRecordStatus {
    Exists = 0,
    NonExistent = 1,
    DifferentCenter = 2
}